import { emojiImageObject } from 'helpers/emojis/emojiImageObject';
import { grey, primaryBlue, primaryBlueLighter } from '../../theme/colors';
import { GraphRadarValue } from 'components/molecules/Charts/GraphRadar';
import {
  Chart,
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
  Filler,
  Title,
  Tooltip,
  SubTitle
} from 'chart.js';
Chart.register(
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
  Filler,
  Title,
  Tooltip,
  SubTitle
);

export const getCanva = (
  values: GraphRadarValue[],
  canvas: CanvasRenderingContext2D
) => {
  const emojisTooltip = values.map(value => emojiImageObject(value.emoji, 18));

  const data = {
    labels: values.map(value => value.type),
    datasets: [
      {
        label: 'Mes compétences',
        data: values.map(value => value.niveau + 1),
        fill: true,
        backgroundColor: primaryBlueLighter,
        borderColor: primaryBlue,
        pointRadius: 70,
        pointStyle: values.map(value => emojiImageObject(value.emoji))
      }
    ]
  };

  return new Chart(canvas, {
    type: 'radar',
    data: data,
    options: {
      layout: {
        padding: 15
      },
      elements: {
        line: {
          borderWidth: 3
        },
        point: {
          hitRadius: 3
        }
      },
      scales: {
        r: {
          min: 0,
          max: 5,
          pointLabels: {
            display: false
          },
          ticks: {
            display: false,
            stepSize: 1
          },
          grid: {
            color: grey.light
          }
        }
      },
      plugins: {
        title: {
          display: false
        },
        legend: {
          display: false
        },
        tooltip: {
          padding: 10,
          titleFont: {
            family: 'Montserrat',
            weight: '600',
            size: 20
          },
          usePointStyle: true,
          callbacks: {
            title(this, tooltipItems) {
              let title = '';
              tooltipItems.forEach(
                element => (title = title + element.label + '\n')
              );
              return title;
            },
            labelPointStyle: labelPointStyle => {
              return {
                pointStyle: emojisTooltip[labelPointStyle.dataIndex],
                rotation: 0
              };
            },
            label: label => {
              return (
                '   Vous êtes au niveau ' +
                (parseInt(label.formattedValue) - 1) +
                ' sur 4'
              );
            }
          }
        }
      }
    }
  });
};
